export const getLoanData = [
  {
    id: 1,
    heading: "Discover the Ultimate Guide to Wedding Loans",
    subHeading:
      "Wedding Loan Guide | Compare Personal Loans for Wedding Expenses in India",
    notice:
      "Explore our complete wedding loan guide to manage your wedding expenses smartly. Compare lenders, understand eligibility, and make an informed financial decision.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",

    heroSectionHeading: "Plan Your Dream Wedding with Smart Financing",
    heroSectionSubHeading:
      "Discover how personal loans for weddings can help you manage expenses while staying financially prudent. Compare lenders and explore tips to make informed decisions.",
  },
];
